import styled from "styled-components"
import PreOwnedBanner from "components/PreOwnedBanner"
import { baseCard } from "../Item"

const PreOwned = styled(PreOwnedBanner)`
  @media (max-width: 767.98px) {
    ${baseCard};
  }

  grid-column: 1 / -1;
  margin-bottom: 0 !important;
`

export default PreOwned
